export default function RedirectIfAuthenticated(router) {
    /**
     * If the user is already authenticated he shouldn't be able to visit
     * pages like login, register, etc...
     */
    router.beforeEach((to, from, next) => {
        let token = window.localStorage.getItem('token');

        /**
         * Checks if there's a token and the next page name is none of the following
         */
        if (
            token &&
            (to.name === 'promo' ||
                to.name === 'auth.login' ||
                to.name === 'auth.confirm' ||
                to.name === 'auth.registration' ||
                to.name === 'auth.confirmRegistration' ||
                to.name === 'auth.forgot')
        ) {
            // redirects according user role
            return next({ path: '/dashboard/portfolio' });
        }

        next();
    });
}
